import { gql } from '__generated__'

/** Links a further Solana wallet to the signed-in account (DEV-321). */
export const LINK_WALLET = gql(`
  mutation linkWallet($walletAddress: String!, $signature: String!) {
    linkWallet(walletAddress: $walletAddress, signature: $signature) {
      id
      address
      isPrimary
      createdAt
    }
  }
`)
